import React from 'react';
import { t } from '../../../i18n';
import { Mutation, Query } from 'react-apollo';
import queries from '../../../queries';
import { useParams } from 'react-router-dom';
import PaletteColorPicker from '../../PaletteColorPicker';

export default function PhotoboothChoiceCellEditor({ cell, screenType, language }) {
    const [cellData, setCellData] = React.useState(cell || {});
    const [isInitialized, setIsInitialized] = React.useState(false); // 🟢 flag ajouté

    const { projectId } = useParams();

    return (
      <Query query={queries.cells.photobooth_choice.get} variables={{ id: cell.id }}>
        {({ loading, error, data }) => {
          if (loading) return <p>{t('ui.common.loading')}</p>;
          if (error) return <p>Error :</p>;
  
          const { photoboothChoiceCell } = data;
  
          // ✅ initialise le state une seule fois
          if (!isInitialized && photoboothChoiceCell) {
            setCellData(photoboothChoiceCell);
            setIsInitialized(true);
          }
  
          return (
            <Mutation
              mutation={queries.cells.photobooth_choice.update}
              variables={{ id: cell.id, data: cellData }}
            >
              {(updateCell, { loading: mutationLoading, error: mutationError }) => {
                if (mutationLoading) return <p>Updating cell...</p>;
                if (mutationError) return <p>Error updating cell: {mutationError.message}</p>;
  
                return (
                  <>
                    <Query query={queries.projects.getWithChildren} variables={{ id: projectId }}>
                      {({ loading, error, data }) => {
                        if (loading) return <p>Loading project...</p>;
                        if (error) return <p>Error loading project: {error.message}</p>;
  
                        const { project } = data;
  
                        return (
                          <div>
                            <label>Text Color</label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.text_color}
                              onChange={(val) => {
                                const { rgb } = val;
                                setCellData({
                                  ...cellData,
                                  text_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`,
                                });
                              }}
                            />
                            <br />
                            <label>Border Color</label>
                            <PaletteColorPicker
                              palette={project.color_palette}
                              color={cellData.border_color}
                              onChange={(val) => {
                                const { rgb } = val;
                                setCellData({
                                  ...cellData,
                                  border_color: `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`,
                                });
                              }}
                            />
                          </div>
                        );
                      }}
                    </Query>
  
                    <label>Email</label>
                    <input
                      type="checkbox"
                      checked={!!cellData.email}
                      onChange={(e) =>
                        setCellData({
                          ...cellData,
                          email: e.target.checked,
                        })
                      }
                    />
                    <br/>
                    <label>Qr Code</label>
                    <input
                      type="checkbox"
                      checked={!!cellData.qr_code}
                      onChange={(e) =>
                        setCellData({
                          ...cellData,
                          qr_code: e.target.checked,
                        })
                      }
                    />
                    <br/>
                    <label>Print</label>
                    <input
                      type="checkbox"
                      checked={!!cellData.print}
                      onChange={(e) =>
                        setCellData({
                          ...cellData,
                          print: e.target.checked,
                        })
                      }
                    />
                    <br />
                    <br />
                    <button
                      onClick={() =>
                        updateCell({
                          variables: {
                            input: removeTypenameDeep(cellData),
                          },
                        })
                      }
                    >
                      Save
                    </button>
                  </>
                );
              }}
            </Mutation>
          );
        }}
      </Query>
    );
  }

function removeTypenameDeep(obj) {
    if (Array.isArray(obj)) {
        return obj.map(removeTypenameDeep);
    } else if (obj !== null && typeof obj === 'object') {
        const newObj = {};
        for (const key in obj) {
            if (key !== '__typename') {
                newObj[key] = removeTypenameDeep(obj[key]);
            }
        }
        return newObj;
    }
    return obj;
}
